/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Enum from 'galax/enum/route';

import BuildingAttack from 'galax/config/route/building.attack';
import BuildingCreateList from 'galax/config/route/building.create.list';
import BuildingCreateType from 'galax/config/route/building.create.type';
import BuildingUpgrade from 'galax/config/route/building.upgrade';

import UnitAttack from 'galax/config/route/unit.attack';
import UnitCreateList from 'galax/config/route/unit.create.list';
import UnitCreateType from 'galax/config/route/unit.create.type';

import TransferCreate from 'galax/config/route/transfer.create';
import ZoneFlow from 'galax/config/route/zone.flow'


let Config = {};


Config[Enum.BuildingAttack]      = BuildingAttack;
Config[Enum.BuildingCreateList]  = BuildingCreateList;
Config[Enum.BuildingCreateType]  = BuildingCreateType;
Config[Enum.BuildingUpgrade]     = BuildingUpgrade;

Config[Enum.UnitAttack]          = UnitAttack;
Config[Enum.UnitCreateList]      = UnitCreateList;
Config[Enum.UnitCreateType]      = UnitCreateType;

Config[Enum.ZoneFlow]            = ZoneFlow;

Config[Enum.TransferEdit]        = TransferCreate;


export default Config;
